














import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Sketch } from 'vue-color'

@Component({
  components: {
    Sketch,
  },
})
export default class ColorPicker extends Vue {
  @Prop() public colorName!: string;
  @Prop() public initColor!: string;
  @Prop() public initShowPicker!: boolean;
  @Prop() public hint!: string;
  showPicker = false;
  currentColor: string = null;

  mounted() {
    this.currentColor = this.initColor
    this.showPicker = this.initShowPicker
  }

  @Watch('initShowPicker')
  onVariable() {
    this.showPicker = this.initShowPicker
  }

  private updateParentColor() {
    this.$emit('updateColor', this.colorName, this.currentColor, this.showPicker)
  }

  public togglePicker() {
    this.showPicker = !this.showPicker
    this.updateParentColor()
    if (this.showPicker) {
      this.$emit('hideColorPickers', this.colorName)
    }
  }

  public updateValue(newColor) {
    this.currentColor = newColor.hex
    this.updateParentColor()
  }
}

